
let games;

async function getGames() {
    const fetchGames = await fetch(window.gamesJsonUrl)
        .then(response => response.json())
        .then(data => {
            return data
        });


    games = processGameOptions(fetchGames)
    //console.log(games)
}

function processGameOptions(fetchGames) {
    // fetchGames.forEach(game => {
    //     game.options.forEach(option => {
    //         const longEdge = option.width > option.length ? option.width : option.length
    //         const shortEdge = option.width < option.length ? option.width : option.length

    //         option.long_edge_size = longEdge
    //         option.short_edge_size = shortEdge
    //     })
    // })

    fetchGames.forEach(game => {

        const longEdge = game.width > game.length ? game.width : game.length
        const shortEdge = game.width < game.length ? game.width : game.length

        game.long_edge_size = longEdge
        game.short_edge_size = shortEdge

    })

    return fetchGames
}

document.addEventListener('DOMContentLoaded', () => {
    getGames()
}) 